import { type SubsProduct } from '@cx-web/domain-types';

import { URL_PARAMS } from '~/apps/product-plus/constants/url-params';

/**
 * Shared utility to restore product selection from URL parameters after login
 * Used across oddschecker-plus landing page templates
 */
export function getPostLoginSubscribeProduct(
  shouldRedirect: boolean,
  searchParams: URLSearchParams,
  availableProducts: SubsProduct[],
  defaultProduct: SubsProduct | undefined,
): SubsProduct | undefined {
  if (!shouldRedirect) {
    return undefined;
  }

  // Restore product selection from URL parameters
  const savedProductId = searchParams.get(URL_PARAMS.PRODUCT_ID);

  if (savedProductId) {
    const selectedProduct = availableProducts.find(p => p.productId === savedProductId);
    if (selectedProduct) {
      return selectedProduct;
    }
  }

  // Fallback to default product if selection not found
  return defaultProduct;
}
